export default {
  noCameras: false,
  categories: null,
  vesselsName: null,
  cameras: []
}
